import './DiningMethods.less';

export const prefix = 'oc-c-dining-methods';

export { default } from './DiningMethods';